<div class="heading">
  <h2>بینش‌های تحلیلی روز</h2>
  <small>جمع‌بندی قابل فهم برای مدیر ناوگان و راننده</small>
</div>

<div class="insights">
  <article class="insight">
    <h3><span aria-hidden="true">◈</span> الگوی شارژ خودرو</h3>
    <p *ngIf="view.movingAverage !== null; else noVoltage">میانگین ولتاژ در حرکت <bdi>{{ view.movingAverage | number:'1.2-2':'en-US' }} V</bdi> است.</p>
    <ng-template #noVoltage><p>دادهٔ معتبر کافی برای محاسبه میانگین ولتاژ در حرکت موجود نیست.</p></ng-template>
    <p class="assessment-note" *ngIf="view.assessmentNote; else chargingHint">{{ view.assessmentNote }}</p>
    <ng-template #chargingHint><p>برای بررسی الگوی شارژ، داده‌های این روز را با سوابق همین خودرو مقایسه کنید.</p></ng-template>
  </article>

  <article class="insight">
    <h3><span aria-hidden="true">◉</span> توقف با موتور روشن</h3>
    <p *ngIf="view.idleDuration !== '—'; else noIdle"><bdi>{{ view.idleDuration }}</bdi> توقف با موتور روشن در گزارش ثبت شده است؛ این زمان می‌تواند مبنای تحلیل اتلاف سوخت باشد، نه محاسبه قطعی مصرف.</p>
    <ng-template #noIdle><p>زمان توقف با موتور روشن برای این روز موجود نیست.</p></ng-template>
  </article>

  <article class="insight">
    <h3><span aria-hidden="true">↗</span> ارتباط سرعت و ولتاژ</h3>
    <p *ngIf="view.correlation !== null; else noCorrelation">ضریب همبستگی نمونه‌های حرکت <bdi>{{ view.correlation | number:'1.3-3':'en-US' }}</bdi> است. تغییرات سرعت الزاماً موجب افزایش ولتاژ نمی‌شوند.</p>
    <ng-template #noCorrelation><p>برای محاسبه همبستگی، نمونه‌های معتبر کافی با تغییرات سرعت و ولتاژ لازم است.</p></ng-template>
  </article>
</div>
